import api from "../axios/axios";

export const loginUser = (data: { email: any; password: any }) => {
  debugger;
  return api.post("/auth/login?adminLogin=true", data);
};
